(() => {
    $(".a__nav[href='#']").on("click", function(e) {
        e.preventDefault();
    });
    // add clicked class to nav links
    $(".a__nav:not([href='javascript:;'])").on("click", function(e) {
        e.currentTarget.classList.add("clicked");
    });
    // remove clicked class from nav links
    $(".a__nav:not([href='javascript:;'])").on("blur", function(e) {
        e.currentTarget.classList.remove("clicked")
    });
})();